import {
  Experiences,
  filterDeliveryThresholdExperiences,
} from "@/components/AddToBasket/utils/utils";
import Script from "next/script";
import { createPortal } from "react-dom";
import { encodeExperiencesObject } from "@/utils/monetate/encodeExperiencesObject.ts";

const DELIVERY_THRESHOLD_SCRIPT_URL =
  "/delivery-threshold/static/js/delivery-threshold.js";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "jl-delivery-threshold": {
        "data-testid"?: string;
        experiences?: string;
      };
    }
  }
}

type Props = {
  experiencesRawObject?: Experiences;
  showPortal: boolean;
};

export const DeliveryThresholdUI = ({
  experiencesRawObject,
  showPortal,
}: Props) => {
  const dlvThresholdExperiences =
    filterDeliveryThresholdExperiences(experiencesRawObject);

  const dlvThresholdExperiencesString =
    Object.keys(dlvThresholdExperiences).length > 0
      ? JSON.stringify(dlvThresholdExperiences)
      : "";

  const propsToPass = dlvThresholdExperiencesString
    ? {
        experiences: dlvThresholdExperiencesString,
        experiencesRawObject: encodeExperiencesObject(
          experiencesRawObject || [],
        ),
      }
    : {};

  return (
    <div data-testid="product:deliveryThreshold">
      <Script
        data-testid="product:deliveryThreshold:script"
        src={DELIVERY_THRESHOLD_SCRIPT_URL}
        type="application/javascript"
      />
      {showPortal &&
        createPortal(
          <jl-delivery-threshold
            {...propsToPass}
            data-testid="product:deliveryThreshold:component"
          />,
          document.body,
        )}
    </div>
  );
};

export default DeliveryThresholdUI;
